import i18n from "@/i18n"

const fields = () => [
  {
    label: i18n.t('delivery.fields.number'),
    key: 'number',
  },
  {
    label: i18n.t('delivery.fields.vendorName'),
    key: 'vendor.name',
  },
  {
    label: i18n.t('delivery.fields.totalRejectionOfDelivery'),
    key: 'delivery_order_count',
  },
]

export default fields
